import React from 'react';

const Builder = () => {
  return <i className="icon scenario-icon scenario-builder" />;
};
const RunNow = () => {
  return <i className="icon scenario-icon scenario-run-now" />;
};
const Schedule = () => {
  return <i className="icon scenario-icon scenario-schedule" />;
};
const OnEvent = () => {
  return <i className="icon scenario-icon scenario-on-event" />;
};
const Wait = () => {
  return <i className="icon scenario-icon scenario-wait" />;
};
const Condition = () => {
  return <i className="icon scenario-icon scenario-condition" />;
};
const Filter = () => {
  return <i className="icon scenario-icon scenario-filter" />;
};
const End = () => {
  return <i className="icon scenario-icon scenario-end" />;
};
const AssignPlaybook = () => {
  return <i className="icon scenario-icon scenario-assign-playbook" />;
};
const CreateTask = () => {
  return <i className="icon scenario-icon scenario-create-task" />;
};
const SetAttribute = () => {
  return <i className="icon scenario-icon scenario-set-attribute" />;
};
const CreatePipeline = () => {
  return <i className="icon scenario-icon scenario-create-pipeline" />;
};
const SendEmail = () => {
  return <i className="icon scenario-icon scenario-send-email" />;
};
const SlackLogo = () => {
  return <i className="icon scenario-icon scenario-slack-message" />;
};
const TeamsLogo = () => {
  return <i className="icon scenario-icon scenario-ms-teams" />;
};
const ConditionalWait = () => {
  return <i className="icon scenario-icon scenario-conditional-wait" />;
};

export {
  Builder,
  RunNow,
  Schedule,
  OnEvent,
  Wait,
  Condition,
  Filter,
  End,
  AssignPlaybook,
  CreateTask,
  SetAttribute,
  CreatePipeline,
  SendEmail,
  SlackLogo,
  TeamsLogo,
  ConditionalWait,
};
